<template>
  <v-container class="pa-0 ma-0" fluid v-resize="onResize">
    <!-- <v-card flat class="pb-0 mb-0">
      <v-card-text class="ma-0 pa-0"> -->
        <v-data-table
          dense
          v-model="selected"
          :show-select="isJbg"
          :items-per-page="pageSize"
          :expanded.sync="expanded"
          :headers="headers"
          :height="tableSize"
          :items.sync="documents"
          :loading="loading"
          item-key="id"
          loading-text="Loading, please wait..."
          no-data-text="No files to show"
          no-results-text="No results found"
          hide-default-footer
          fixed-header
          @click:row="getDocDetails">
          <template v-slot:top>
            <v-toolbar flat color="toolbar" height="75" style="cursor: default">
              <span>
                <v-toolbar-title>{{ sectionTitle }}</v-toolbar-title>
              </span>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-col cols="3" class="pl-0">
                <PartySelect
                  :selectedParties.sync="selectedParties"
                  :includeOwnerRetailerAdGroups="true"
                  @remove="removeParty">
                </PartySelect>
              </v-col>
                <DocumentTags
                  :filteredIds="excludedSubcategories"
                  @cancelLoad="() => loading = false"
                  v-model="tags"
                />
              <v-col v-if="isJbg" cols="2" class="d-flex align-center">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      height="40"
                      class="flex-grow-1 text-none px-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>mdi-calendar-range</v-icon>
                      <span class="text-truncate">{{ dateRangeLabel || 'Created date' }}</span>
                    </v-btn>
                  </template>
                  <v-date-picker
                    v-model="dateRange"
                    range
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateRange = []">Clear</v-btn>
                    <v-btn text color="primary" @click="dateMenu = false">Done</v-btn>
                  </v-date-picker>
                </v-menu>
                <v-btn
                  v-if="dateRange.length > 0"
                  icon
                  small
                  class="ml-1"
                  title="Clear date range"
                  @click="clearDateRange"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="2" class="d-flex align-center">
                <v-text-field
                  class="flex-grow-1 rounded-r-0"
                  v-model="filterText"
                  label="Filter"
                  placeholder="Filter page by file name or description"
                  prepend-inner-icon="mdi-text-search-variant"
                  hide-details="auto"
                  background-color="input"
                  dense
                  outlined
                  clearable
                  @keyup.enter="resetAndSearch()"
                />
                <v-btn
                  class="rounded-l-0"
                  color="primary"
                  depressed
                  height="40"
                  @click="resetAndSearch()"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-btn
                v-if="isJbg"
                class="ml-4"
                color="primary"
                depressed
                height="40"
                :disabled="selected.length === 0"
                :loading="downloadingBulk"
                @click="downloadBulkSelected"
              >
                <v-icon left>mdi-folder-download-outline</v-icon>
                Download selected ({{ selected.length }})
              </v-btn>
            </v-toolbar>
          </template>
           <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="(headers.length)">
              <span v-for="(meta, metaKey) in item.metadata" :key="metaKey">
                <strong v-text="metaKey"></strong> {{meta}}
                <v-divider class="ml-2 mr-2" vertical />
              </span>
              <template v-if="!item.metadata && item.parties.length === 0">
                There is no metadata attached to this document
              </template>
            </td>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <span v-if="isAdminUser">
              {{ item.name }}
            </span>
            <v-tooltip v-else top open-delay="400">
              <template v-slot:activator="{ on, attrs }">
                <span style="cursor: pointer" v-on="on" v-bind="attrs">
                  {{ item.name }}
                </span>
              </template>
              <span>Click to Download</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="text-no-wrap">
              <v-icon class="mr-2" @click.stop="downloadFile(item.id)">
                mdi-file-download-outline
              </v-icon>
              <v-btn v-if="isAdminUser" icon @click.stop="openDeleteDialog(item)">
                <v-icon class="mr-2">mdi-trash-can-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.tags.category`]="{ item }">
            <span v-if="item.tags.category">
              {{ getCategoryName(item.tags.category) }}
            </span>
          </template>
          <template v-slot:[`item.tags.subcategory`]="{ item }">
            <span v-if="item.tags.subcategory !== '' && item.tags.subcategory !== null">
              {{ getSubcategoryName(item.tags.category, item.tags.subcategory) || '-' }}
            </span>
          </template>
          <template v-slot:[`item.tags.subtype`]="{ item }">
            <span v-if="item.tags.subtype">
              {{getSubtypeName(item.tags.category, item.tags.subcategory, item.tags.subtype)  }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:footer>
            <v-divider></v-divider>
            <v-toolbar flat color="toolbar">
                <v-spacer></v-spacer>
                <v-col cols="2" sm="3" style="max-width:150px;">
                  <v-select
                    class="mt-8"
                    dense
                    :items="pageSizes"
                    label="Items Per Page"
                    v-model="pageSize"
                    :menu-props="{ top: true, offsetY: true, maxHeight: 500 }">
                  </v-select>
                </v-col>
                <v-btn
                  icon
                  large
                  @click="previous();"
                  :disabled="disablePrevious"
                  class="mx-2">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <small>Page {{ page }}</small>
                <v-btn icon large
                  @click="next();"
                  :disabled="disableNext"
                  class="mx-2">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-toolbar>
            <v-dialog v-if="showDeleteDialog" v-model="showDeleteDialog" @click:outside="showDeleteDialog = false; selectedDocument = {}" width="450">
              <v-card>
                <v-card-title>Delete Document</v-card-title>
                <v-card-text>
                  Delete "{{ selectedDocument.name }}"?
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn :class="body" text @click="showDeleteDialog = false">Close</v-btn>
                  <v-btn :class="body" class="red white--text" @click.stop='deleteDoc(selectedDocument)'>Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      <!-- </v-card-text>
    </v-card> -->
  </v-container>
</template>
<script lang="js">
// mixins
import { displayAlert } from '@/mixins/alert'
import { fullwidth } from '@/mixins/fullwidth'
import { userAccess } from '@/mixins/user-access'
import { paging } from '@/mixins/paging'

// api
import document from '@/axios/document.ts'
import file from '@/axios/file.ts'

// third party helpers
import { format } from 'date-fns'

// components
import DocumentTags from '@/components/DocumentTags.vue'
import PartySelect from '@/components/PartySelect.vue'

export default {
  name: 'DocList',
  data: () => ({
    loading: true,
    docDetails: {},
    documents: [],
    selected: [],
    downloadingBulk: false,
    hasMore: false,
    searchSeq: 0,
    dateRange: [],
    dateMenu: false,
    appliedDateKey: '',
    selectedParties: [],
    selectedDocument: {},
    showDeleteDialog: false,
    items: [],
    filterText: '',
    tags: {
      category: '',
      subcategory: '',
      subtype: '',
      status: ''
    },
    expanded: [],
  }),
  mixins: [displayAlert, fullwidth, userAccess, paging],
  components: { DocumentTags, PartySelect },
  watch: {
    selectedParties: {
      handler (newValue) {
        if (newValue?.length > 0) {
          sessionStorage.setItem('selected_parties', JSON.stringify(newValue))
        } else {
          sessionStorage.removeItem('selected_parties')
        }
        this.resetAndSearch()
      },
      deep: true
    },
    sectionCategories: {
      handler (newValue) {
        if (newValue?.length > 0) {
          this.initTags()
        }
      },
      deep: true
    },
    tags: {
      handler (newValue) {
        if (newValue) {
          sessionStorage.setItem(this.tagsStorageKey, JSON.stringify(newValue))
          this.resetAndSearch()
        }
      },
      deep: true
    },
    userRelatedPartyIds: {
      handler (newValue) {
        if (newValue?.length > 0 && this.isNonAdminUser && this.selectedParties.length === 0) {
          this.searchDocuments()
        }
      },
      deep: true
    },
    dateMenu (isOpen) {
      // Apply the date filter only when the picker closes (Done / click-away),
      // not on every intermediate day click, to avoid mid-selection search churn.
      if (!isOpen) this.applyDateRange()
    },
    filterText (newValue, oldValue) {
      if ((newValue === '' || newValue === null) && oldValue) {
        this.resetAndSearch()
      }
    }
  },
  created () {
    this.nonTableHeight = 240
    if (sessionStorage.selected_parties) {
      this.selectedParties = JSON.parse(sessionStorage.selected_parties)
    }
    this.tableChanged = this.tableChange(this.searchDocuments)
    if (this.doc_tags.length > 0) {
      this.initTags()
    }
  },
  mounted() {
    this._refreshDocumentsHandler = () => { this.searchDocuments() };
    this.eventbus.$on('refreshDocuments', this._refreshDocumentsHandler);
  },
  beforeDestroy() {
    if (this._refreshDocumentsHandler) {
      this.eventbus.$off('refreshDocuments', this._refreshDocumentsHandler);
    }
  },
  computed: {
    headers() {
      return [
        { sortable: false, class: 'accent', filterable: false, show: true },
        { text: 'Name', class: 'accent white--text', value: 'name', sortable: true, filterable: true, show: true },
        { text: 'Description', class: 'accent white--text', value: 'description', sortable: true, filterable: true, show: true },
        { text: 'Category', class: 'accent white--text', value: 'tags.category', sortable: true, filterable: false, show: true },
        { text: 'Subcategory', class: 'accent white--text', value: 'tags.subcategory', sortable: true, filterable: false, show: true },
        { text: 'Subtype', class: 'accent white--text', value: 'tags.subtype', sortable: true, filterable: false, show: this.$auth.tenant === 'alliance-retail-group' },
        { text: 'Last Updated', class: 'accent white--text', value: 'audit.updated_on', sortable: true, filterable: false, show: true },
        { text: 'Actions', class: 'accent white--text', value: 'actions', sortable: false, filterable: false, show: true }
      ].filter(h => h.show)
    },
    selectedPartyIds () {
      if (this.selectedParties.length > 0) {
        return this.selectedParties.map(party => (party.party_id || party.id))
      }
      return []
    },
    doc_tags () {
      return this.$store.getters.doc_tags
    },
    isJbg () {
      return this.tenant === 'jbg'
    },
    // Files and Finance each remember their own filters.
    tagsStorageKey () {
      return this.docSection === 'finance' ? 'finance-selected-tags' : 'selected-tags'
    },
    dateRangeLabel () {
      const range = [...this.dateRange].filter(Boolean).sort()
      if (range.length === 0) return ''
      if (range.length === 1) return `From ${range[0]}`
      return `${range[0]} – ${range[1]}`
    },
    disablePrevious () {
      return ((this.page - 1) * this.pageSize) === 0
    },
    disableNext () {
      return !this.hasMore
    }
  },
  methods: {
    removeParty (index) {
      this.selectedParties.splice(index, 1)
    },
    onResize () {
      this.tableHeight = window.innerHeight - 240
    },
    initTags () {
      const stored = sessionStorage.getItem(this.tagsStorageKey)
      if (stored) {
        return this.tags = this.getFilteredTags(JSON.parse(stored))
      }
      this.tags = this.getFilteredTags(this.tags)
    },
    getFilteredTags (tags) {
      if (this.sectionCategories.length === 0) return tags
      const validCat = this.sectionCategories.find(c => c?.id === tags.category)
      if (!validCat) {
        tags.category = this.sectionCategories[0].id
      }
      const subcategories = this.getSubcategories(tags.category)
        .filter(c => !this.excludedSubcategories.includes(c.id))
      const subcategory = subcategories.find(c => c.id === tags.subcategory)
      if (!subcategory) {
        tags.subcategory = ''
        tags.subtype = ''
      } else {
        const subtypes = this.getSubtypes(tags.subcategory)
        const subtype = subtypes?.find(c => c.id === tags.subtype)
        if (!subtype) {
          tags.subtype = ''
        }
      }
      if (!tags.status) tags.status = 'CURRENT'
      return tags
    },
    // Reset to the first page and search exactly once. Changing `page` drives
    // the search (via the `paging` mixin's `page` watcher, which also updates
    // the offset); when already on page 1 we search directly. This avoids the
    // old pattern of searching with a stale offset and then double-firing.
    resetAndSearch () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.searchDocuments()
      }
    },
    async searchDocuments () {
      let partyIds = []
      if (this.selectedPartyIds.length > 0) {
        partyIds.push(...this.selectedPartyIds)
      }
      if (this.sectionSearchBlocked) return
      // The exemption has to sit ahead of the early return as well as the party
      // filter: an internal user with no related parties would otherwise never
      // issue the search at all.
      if (partyIds.length === 0 && this.isNonAdminUser && !this.isPartyExemptCategory(this.tags.category)) {
        if (this.userRelatedPartyIds.length === 0) return
        partyIds = this.buildPartyIdParams()
      }
      this.loading = true
      // the result set is changing — drop selections so bulk actions can't
      // target rows that are no longer visible.
      this.selected = []
      // sequence guard: only the most recently issued search may commit its
      // results, so a slow earlier request can't overwrite newer results.
      const seq = ++this.searchSeq
      const tags = this.buildTagParams()
      let documents = []
      let hasMore = false
      const data = { party_ids: partyIds, excluded_subcategories: this.excludedSubcategories, filter_text: this.filterText, ...this.buildDateRangeParams() }
      try {
        // request one extra row to reliably detect whether a next page exists
        const res = await document.search(data, tags, this.from, this.pageSize + 1)
        if (seq !== this.searchSeq) return
        if (res.data?.length > 0) {
          hasMore = res.data.length > this.pageSize
          documents = res.data.slice(0, this.pageSize).map(doc => {
            doc.audit.created_on = this.formatTimestamp(doc.audit.created_on)
            doc.audit.updated_on = this.formatTimestamp(doc.audit.updated_on)
            return doc
          })
        }
        this.documents = documents
        this.hasMore = hasMore
      } catch (err) {
        if (seq !== this.searchSeq) return
        this.handleError(err)
      } finally {
        if (seq === this.searchSeq) this.loading = false
      }
    },
    applyDateRange () {
      // Only fire a search when the effective range actually changed since the
      // last apply, so opening/closing the picker without edits is a no-op.
      const key = JSON.stringify([...this.dateRange].filter(Boolean).sort())
      if (key === this.appliedDateKey) return
      this.appliedDateKey = key
      this.resetAndSearch()
    },
    clearDateRange () {
      this.dateRange = []
      this.applyDateRange()
    },
    buildPartyIdParams () {
      let partyIds = this.userSearchPartyIds
      if (this.tags.subcategory === 'RETAILER_SRP_ALERT') {
        // 250 limit to avoid overloading the API
        partyIds = this.userStorePartyIds.slice(0, 250)
      } else if (this.tags.category === 'VENDOR_REPORT' && this.isPromoCoordinator) {
        // promo coordinators have unrestricted vendor access
        partyIds = []
      }
      return partyIds
    },
    buildTagParams () {
      // Normalize into a copy — mutating `this.tags` here would re-trigger the
      // deep `tags` watcher and fire a redundant recursive search.
      const normalized = { ...this.tags }
      if (normalized.subcategory && !normalized.category) {
        normalized.subcategory = null
      }
      if (!normalized.subcategory && normalized.subtype) {
        normalized.subtype = null
      }
      const entries = Object.entries(normalized).filter(([, v]) => v !== '' && v !== null)
      return entries.length > 0 ? Object.fromEntries(entries) : {}
    },
    buildDateRangeParams () {
      // Filter by `created_on` (portal ingest date). Empty range → omit both
      // fields (unfiltered). A single selected date is treated as an open-ended
      // lower bound (from that day onward).
      //
      // Backend contract (DocumentSearchVM): `start_date` / `end_date` are
      // DATE-typed and the query is inclusive of the full end day. The picker
      // already yields plain YYYY-MM-DD day strings, so send them as-is — the
      // backend owns day-boundary/timezone handling. (Sending UTC instants here
      // would shift the day for users behind UTC and is what previously left
      // the filter a no-op via mismatched field names.)
      const range = [...this.dateRange].filter(Boolean).sort()
      if (range.length === 0) return {}
      const params = { start_date: range[0] }
      if (range.length > 1) {
        params.end_date = range[range.length - 1]
      }
      return params
    },
    openDeleteDialog(item) {
      this.selectedDocument = item
      this.showDeleteDialog = true
    },
    async deleteDoc (item) {
      try {
        await document.delete(item.id)
        this.emitAlert(true, 'success', `${item.name} has been successfully deleted`)
        this.$gtag.event('document_delete', {
          category: 'documents',
          document_id: item.id
        })
        this.searchDocuments()
        this.showDeleteDialog = false
        this.selectedDocument = {}
      } catch (err) {
        this.handleError(err)
      }
    },
    async downloadFile (id) {
      try {
        const res = await file.get(id)
        const url = res.data?.url
        if (url) {
          window.open(url, '_blank')
          this.$gtag.event('document_download', {
            category: 'documents',
            document_id: id
          })
        }
      } catch (err) {
        this.handleError(err)
      }
    },
    async downloadBulkSelected () {
      if (this.selected.length === 0) return
      // fail fast client-side with a friendly message rather than a server 400.
      // The limit is centralized in document_config; the server 400 path
      // (handleBulkDownloadError) still backstops any drift from the API.
      const maxBulkDownload = this.$config.maxBulkDownload
      if (this.selected.length > maxBulkDownload) {
        return this.emitAlert(true, 'warning', `You can download up to ${maxBulkDownload} documents at once. Please select fewer and try again.`)
      }
      this.downloadingBulk = true
      const ids = this.selected.map(doc => doc.id)
      try {
        const res = await document.downloadBulk(ids)
        // `document` is the axios wrapper (imported above), so reach the DOM
        // via `window.document` to build the synthetic download link.
        const blob = new Blob([res.data], { type: res.data?.type || 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const link = window.document.createElement('a')
        link.href = url
        link.download = this.getBulkFilename(res.headers)
        window.document.body.appendChild(link)
        link.click()
        window.document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        // some selected docs may have had no file; the API reports how many it
        // skipped so the toast can reflect what actually downloaded, not just
        // what was selected.
        const missing = Number(res.headers?.['x-missing-documents']) || 0
        const delivered = ids.length - missing
        this.$gtag.event('documents_bulk_download', {
          category: 'documents',
          count: delivered
        })
        if (missing > 0) {
          this.emitAlert(true, 'success', `Downloading ${delivered} of ${ids.length} documents — ${missing} had no file and ${missing === 1 ? 'was' : 'were'} skipped.`)
        } else {
          this.emitAlert(true, 'success', `Downloading ${delivered} document${delivered === 1 ? '' : 's'}.`)
        }
        this.selected = []
      } catch (err) {
        await this.handleBulkDownloadError(err)
      } finally {
        this.downloadingBulk = false
      }
    },
    getBulkFilename (headers) {
      const fallback = `documents-${format(new Date(), 'yyyy-MM-dd')}.zip`
      const disposition = headers?.['content-disposition']
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
        if (match?.[1]) return decodeURIComponent(match[1])
      }
      return fallback
    },
    async handleBulkDownloadError (err) {
      // With responseType 'blob', error bodies also arrive as a Blob, so the
      // standard handleError can't read the message — parse it out first.
      // FastAPI returns HTTPException bodies as { detail: <message> }.
      const response = err?.response
      const data = response?.data
      if (data instanceof Blob) {
        try {
          const parsed = JSON.parse(await data.text())
          const message = parsed?.detail || parsed?.message
          if (message) {
            return this.emitAlert(true, 'warning', message)
          }
        } catch (e) {
          // not JSON — fall through to status-based messaging
        }
      }
      // backend caps a single bulk request and rejects an over-limit selection with 400
      if (response?.status === 400) {
        return this.emitAlert(true, 'warning', 'Your selection is too large to download at once. Please select fewer documents and try again.')
      }
      this.handleError(err)
    },
    expandRow (value, $event) {
      const rowIdx = this.expanded.indexOf(value)
      if (rowIdx >= 0) {
        this.expanded.splice(rowIdx, 1)
      } else {
        this.expanded.push(value)
        this.getDocDetails($event, value.id)
      }
    },
    getDocDetails (doc) {
      if (this.isAdminUser) {
        return this.$router.push({
          name: 'Edit',
          query: { id: doc.id }
        })
      } else {
        this.downloadFile(doc.id)
      }
    },
    formatTimestamp (time) {
      const date = new Date(time)
      // guard against null/invalid values so one bad row can't throw and abort
      // the whole result mapping.
      if (isNaN(date.getTime())) return ''
      return format(date, this.$config.timestamp)
    },
    getCategoryName (categoryId) {
      const category = this.categories.find(c => c.id === categoryId)
      return category?.name || ''
    },
    getSubtypeName (categoryId, subcategoryId, subTypeId) {
      const subcategories = this.getSubcategories(categoryId)
      const subcategory = subcategories.find(s => s.id === subcategoryId)
      const subtypes = subcategory?.children?.find(c => c.id === 'SUBTYPE')?.children || []
      const subtype = subtypes.find(s => s.id === subTypeId)
      return subtype?.name || ''
    },
    getSubcategoryName (categoryId, subcategoryId) {
      const subcategories = this.getSubcategories(categoryId)
      const subcategory = subcategories.find(s => s.id === subcategoryId)
      return subcategory?.name || ''
    },
    getSubcategories (catId) {
      const category = this.categories.find(c => c.id === catId)
      if (category) {
        const subcategoryTag = category.children.find(c => c.id === 'SUBCATEGORY')
        return subcategoryTag?.children || []
      }
      return []
    },
    getSubtypes (subcatId) {
      if (this.subcategories?.length > 0) {
        const subcategory = this.subcategories?.find(c => c.id === subcatId)
        if (subcategory?.children?.length > 0) {
          const subtype = subcategory.children.find(c => c.id === 'SUBTYPE')
          return subtype?.children || []
        }
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep tbody tr.v-data-table__expanded__content {
  background: #efefef;
  box-shadow: none !important;
}
</style>
